<template>
    <i
        v-if="platformIncidents === null"
        class="fa-thin fa-circle-exclamation opacity-50"
        v-tooltip="'ZynoSuite is unable to check the platform status.'"
    ></i>
    <i
        v-else-if="hasPlatformIncidentUpdate || openPlatformIncidents?.length"
        v-tooltip="
            openPlatformIncidents?.length
                ? 'The Zyno platform is experiencing issues. Click for more details.'
                : 'All Zyno platform incidents have been resolved. Click to dismiss.'
        "
        class="fa-solid fa-circle-exclamation incident"
        :class="{ resolved: openPlatformIncidents?.length === 0, 'fa-bounce': hasPlatformIncidentUpdate }"
        @click="openOrAckPlatformStatus"
    ></i>
</template>

<script lang="ts" setup>
import { usePlatformIncidents } from '../exports/incidents';

const { platformIncidents, openPlatformIncidents, hasPlatformIncidentUpdate, openOrAckPlatformStatus } = usePlatformIncidents();
</script>

<style scoped>
@reference '#tw.css';

.incident {
    @apply !text-red-300;

    &.resolved {
        @apply !text-green-300;
    }
}
</style>
